import { format } from 'date-fns';
/* eslint-disable */
export default {
  getLIs(state) {
    const formatarData = (valor) => {
      if (!valor) {
          return 'N/I';
      }

      return format(new Date(valor), 'dd/MM/yyyy');
    }
    return state.LIs.map(item => ({
      ...item,
      dataSituacaoFormat: formatarData(item.dataSituacao),
      dataRegistroFormat: formatarData(item.dataRegistro),
      dataValidadeSituacaoFormat: formatarData(item.dataValidadeSituacao),
      dataProtocoloFormat: formatarData(item.dataProtocolo),
    }));
  },
  getLIsList(state) {
    return state.LIs;
  },
  getItens(state) {
    return state.itens;
  },
  getAnuencia(state) {
    return state.anuencia;
  },
  getAnuenciaAsObject(state) {
      const anuencia = {
        1: '-',
        3: '-',
        4: '-',
        5: '-',
        9: '-',
        10: '-',
      };

      state.anuencia.forEach(_a => {
        const { codigoSituacao, dataSituacao } = _a;
        anuencia[Number(codigoSituacao)] = dataSituacao;
      });

      return {
        paraAnalise: anuencia[1],
        emExigencia: anuencia[3],
        indeferido: anuencia[4],
        deferido: anuencia[5],
        cancelados: anuencia[9],
        embarqueAutorizado: anuencia[10],
      }
  },
  getFiltros(state) {
    return state.filtros;
  },
  getCampos(state) {
    return state.campos;
  },
  getColDefault(state) {
    return state.colDefault;
  },
  getDirectionDefault(state) {
    return state.directionDefault;
  },
};
